import { Container, Message } from "semantic-ui-react";

import { FileDragDrop } from "components";
import { useRecallsUpload } from "modules/RecallsUpload/hooks/useRecallsUpload";
import "modules/RecallsUpload/RecallsUpload.scss";

const RecallsUpload = () => {
  const { upload, isError, isSuccess } = useRecallsUpload();

  const handleFileUpload = (files: FileList | null) => {
    if (files && files.length > 0) upload(files[0]);
  };

  return (
    <>
      <Container className="RecallsContainer">
        <FileDragDrop id="recalls-upload-dnd" onFileUpload={handleFileUpload} accept=".xlsx" />

        {isSuccess && (
          <Message positive>
            <Message.Header>Upload Successful</Message.Header>
            <p>Your file has been uploaded successfully.</p>
          </Message>
        )}
        {isError && (
          <Message negative>
            <Message.Header>Upload Failed</Message.Header>
            <p>{isError}</p>
          </Message>
        )}
      </Container>
    </>
  );
};

export default RecallsUpload;
